import * as Phaser from 'phaser';
import { PaintedScene } from '../PaintedScene';
import {
  installSnowTexture,
  installBreathTexture,
  createSnowfall,
  createBreathMist,
} from './frostmereAmbient';

export const FROST_BRIDGE_APPROACH_PHASER_KEY = 'FrostBridgeApproachScene' as const;
export const FROST_BRIDGE_APPROACH_MANIFEST_KEY = 's-308-frost-bridge-approach' as const;

export class FrostBridgeApproachScene extends PaintedScene {
  private snowEmitter: Phaser.GameObjects.Particles.ParticleEmitter | null = null;
  private breathEmitter: Phaser.GameObjects.Particles.ParticleEmitter | null = null;

  constructor() {
    super(FROST_BRIDGE_APPROACH_PHASER_KEY, FROST_BRIDGE_APPROACH_MANIFEST_KEY);
  }

  preload(): void {
    super.preload();
    installSnowTexture(this);
    installBreathTexture(this);
  }

  protected override onSceneReady(): void {
    this.snowEmitter = createSnowfall(this, 0.6);

    if (this.walker) {
      this.breathEmitter = createBreathMist(this, this.walker);
    }
  }

  protected override onSceneShutdown(): void {
    this.snowEmitter?.destroy();
    this.breathEmitter?.destroy();
    this.snowEmitter = null;
    this.breathEmitter = null;
  }
}
